module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/colorado-81067fd50453b03c4a6530e1ee70ad9c.jpg";